import BreakpointsEnum from "../enums/breakpointsEnum";

let $mainSlider = $('.product-slider .main');

// must be before initializing slick
$mainSlider.on('init', function (slick) {
    if ([BreakpointsEnum.desktop, BreakpointsEnum.largeDesktop].includes(window.App.getBreakpoint())) {
        let $img = $mainSlider.find('img:eq(0)');

        $img.closest('.img-fill').zoom({
            url: $img.data('zoom')
        });
    }
});

// must be before initializing slick
$mainSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    if ([BreakpointsEnum.desktop, BreakpointsEnum.largeDesktop].includes(window.App.getBreakpoint())) {
        let $currentImg = $mainSlider.find(`img:eq(${currentSlide})`);
        $currentImg.closest('.img-fill').trigger('zoom.destroy');

        let $nextImg = $mainSlider.find(`img:eq(${nextSlide})`);
        $nextImg.closest('.img-fill').zoom({
            url: $nextImg.data('zoom')
        });
    }
});

$mainSlider.slick({
    arrows: false,
    dots: false,
    fade: true,
    infinite: false,
    asNavFor: '.product-slider .thumbnail',
    rows: 0,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                dots: true,
                fade: false,
                asNavFor: null
            }
        }
    ]
});

$(window).on('resize', function () {
    let currentSlide = $mainSlider.slick('slickCurrentSlide');
    let $currentImg = $mainSlider.find(`img:eq(${currentSlide})`);
    let $zoomImg = $currentImg.closest('.img-fill').find('.zoomImg');

    if ($zoomImg.length && [BreakpointsEnum.tablet, BreakpointsEnum.mobile].includes(window.App.getBreakpoint())) {
        $currentImg.closest('.img-fill').trigger('zoom.destroy');
    }

    if ((!$zoomImg.length) && [BreakpointsEnum.desktop, BreakpointsEnum.largeDesktop].includes(window.App.getBreakpoint())) {
        $currentImg.closest('.img-fill').zoom({
            url: $currentImg.data('zoom')
        });
    }
});

$(document).on('click', 'img.zoomImg', function () {
    let currentSlide = $mainSlider.slick('slickCurrentSlide');
    let $currentImg = $mainSlider.find(`img:eq(${currentSlide})`);
    $currentImg.trigger('click');
});